import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    console.log('[TriggerAdder] Controller connected')
  }

  toggle() {
    console.log('[TriggerAdder] Toggle clicked')
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle('hidden')
    }
  }
}
